import { useState, useEffect } from 'react';
import { fetchSEOData } from '../components/seoService';

export const useSEO = (pagePath) => {
  const [seoData, setSeoData] = useState({
    title: 'Restaurant Name',
    description: 'Welcome to our restaurant',
    keywords: 'restaurant, dining',
    robots: 'index, follow'
  });
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSEO = async () => {
      try {
        setLoading(true);
        const data = await fetchSEOData(pagePath);
        if (data && data.seo) {
          setSeoData(data.seo);
          setContent(data.content || null);
        }
      } catch (error) {
        console.error('Error loading SEO:', error);
      } finally {
        setLoading(false);
      }
    };
    loadSEO();
  }, [pagePath]);

  return { seoData, content, loading };
};